import React from 'react';
import './Operator.css'

export default function Operator (props) {

    return (
        <div className="operator" onClick = {() => props.setOperator(props.operator)}>
            {props.operator}
        </div>
    )
    
} 